<template>
  <div class="etc-info--wrap dimmed" @click.self="$emit('onCloseClick')">
    <div>
      <table>
        <caption>
          <b>{{ title }} {{ $t('common.etc') }}</b>
        </caption>
        <thead>
        <tr>
          <th class="url">
            {{ title }}
          </th>
          <th class="pv">PV</th>
          <th class="rate">{{ $t('common.rate') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in etcData.items" :key="index">
          <td class="url">
            <div class="ellipsis">
              <button type="button" v-if="item.url !== 'Direct'" class="outlink icon icon--link-size16"
                @click="$emit('onUrlClick', type, item.url)"></button>
              {{ item.url }}
            </div>
          </td>
          <td class="pv">
            <span>{{ item.count | thousand }}</span>
          </td>
          <td class="rate">
            <div class="bar"><div class="bar_inner"
              :style="{ width: item.percentage + 'px' }"></div></div>
            <span>{{ item.percentage | fixed(1) }}%</span>
          </td>
        </tr>
        </tbody>
      </table>
      <button class="close" @click="$emit('onCloseClick')">
        <i class="icon icon--close-btn"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EtcList',
  props: [
    'etcData'
  ],
  computed: {
    type () {
      return this.etcData.type
    },
    title () {
      switch (this.type) {
        case 'referer':
          return this.$t('analytics.content.inflow.title')
        case 'conversion':
          return this.$t('analytics.content.inflow.conversionChannel')
        default:
          throw new Error('invalid type')
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
.etc-info--wrap {
  & > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 830px;
    max-height: 574px;
    border-radius: 14px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    color: #666666;
    padding: 30px 30px 35px;
    box-sizing: border-box;
    overflow: hidden;
  }

  table {
    width: 100%;
    text-align: center;
    table-layout: fixed;
    border-collapse: collapse;

    caption {
      text-align: left;
      font-size: 15px;
      font-weight: 600;
      color: #2f2f2f;
      margin-bottom: 50px;

      span {
        font-size: 12px;
        color: $brandColor;
        margin-left: 20px;
        display: inline-block;
      }
    }

    .url {
      width: 484px;
      text-align: left;
    }
    .pv {
      width: 100px;
      text-align: right;
    }
    .rate {
      width: 185px;
    }

    thead tr{
      display: block;
      th {
        box-sizing: border-box;
        padding-bottom: 8px;
        border-bottom: 1px solid #bbbbbb;
        line-height: 1.23;
        font-size: 13px;
        color: #666666;
        font-weight: 500;

        span {
          display: inline-block;
          white-space: nowrap;
          width: 63px;
          text-align: right;
          position: relative;
          left: -10px;
        }
      }
      .url {
        text-align: center;
      }
    }

    tbody {
      display: block;
      overflow: auto;
      width: 100%;
      max-height: 420px;
      color: #2f2f2f;
      font-weight: 500;

      tr {
        height: 50px;
        border-bottom: 1px solid #ebebeb;
        box-sizing: border-box;
      }
    }
    tr {
      td {
        box-sizing: border-box;
      }
      .url {
        .outlink {
          position: absolute;
          top: 0;
          left: 6px;
        }

        &> div {
          position: relative;
          width: 484px;
          height: 20px;
          box-sizing: border-box;
          padding-top: 3px;
          padding-left: 30px;
        }
      }
      .rate {
        padding-left: 29px;
        .bar {
          width: 100px;
          height: 10px;
          display: inline-block;
          border-radius: 5px;
          background-color: #ebebeb;
          overflow: hidden;
          margin-right: 8px;

          .bar_inner {
            height: 100%;
            background-color: $brandColor;
          }
        }
      }
    }
  }

  button.close {
    position: absolute;
    top: 0;
    right: 0;
    padding: 12px;
  }
}
</style>
